module.exports = __webpack_public_path__ + "img/category_2.76690653.svg";